module.exports = __webpack_public_path__ + "img/ios_model_area_1000.6565bbb1.jpg";